 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-47e91daa":"6cd93ccd","chunk-1c946adc":"98dbe05d","chunk-af25d5ee":"a6f529e5","chunk-0b65ffb6":"54bfc614","chunk-2d0a3577":"28429d9c","chunk-2d0a43df":"570cad7c","chunk-2d0aa90c":"191e1dbd","chunk-2d0aab07":"dd4975d9","chunk-2d0abc00":"8f429d39","chunk-2d0ae937":"f79863cf","chunk-2d0aeb45":"8180a9a7","chunk-2d0af08c":"f126267a","chunk-2d0afa49":"7019b325","chunk-2d0b6187":"931f6e10","chunk-2d0ba136":"c4160e6c","chunk-2d0bb267":"81cdee70","chunk-2d0bcec1":"a2325562","chunk-2d0bdf38":"15c3cfe5","chunk-2d0bff92":"70fee63d","chunk-2d0c0494":"435a71e5","chunk-2d0c0a09":"7d3468dc","chunk-2d0c4313":"94731674","chunk-2d0c46d1":"f9e7df61","chunk-2d0c512b":"0e6faa36","chunk-2d0cf16e":"87a22b7b","chunk-2d0d056d":"14b9827a","chunk-2d0d0645":"ef556a48","chunk-2d0d2f22":"95d1114b","chunk-2d0d61fd":"a981c3cd","chunk-2d0d7e63":"1009db2d","chunk-2d0e1b57":"6fff2175","chunk-2d0e1fbe":"0edf64f2","chunk-2d0e22d6":"b68bb6ff","chunk-2d0e542a":"996d98e0","chunk-2d0e57ec":"fd0fd799","chunk-2d0e6553":"321d925b","chunk-2d0e6c86":"87438fc9","chunk-2d0ea098":"ad19a9e6","chunk-2d0f0a11":"d42bfa95","chunk-2d208ac5":"f0879abd","chunk-2d209408":"c26b354c","chunk-2d20f745":"93fa43f9","chunk-2d20ff23":"b3ef1a58","chunk-2d2138c7":"9ca3e24c","chunk-2d216f3b":"f10a3a33","chunk-2d217e5b":"999cd62f","chunk-2d21b84a":"94b8835c","chunk-2d21dcd2":"949a5f33","chunk-2d21f327":"aa369cc6","chunk-2d2214b3":"1747e6b0","chunk-2d221799":"0dfeb478","chunk-2d221814":"d295d54c","chunk-2d221a34":"2b8aff3f","chunk-2d22502a":"2cd96846","chunk-2d226775":"92f87a5e","chunk-2d229411":"7e37c80f","chunk-2d2295e9":"6079ffe1","chunk-2d22c171":"acae450e","chunk-2d22c2b8":"5f61e76f","chunk-2d22ca58":"fdc63f08","chunk-2d2311f7":"558f1b9a","chunk-2d237ee7":"c6234986","chunk-2d238465":"c444bbae","chunk-30597b4a":"5bb86637","chunk-7459c510":"05da81ce","chunk-7532b3ea":"ffcc3432","chunk-e13e4362":"55385beb"}[chunkId] + ".js"
 	}

 	// object to store loaded and loading wasm modules
 	var installedWasmModules = {};

 	function promiseResolve() { return Promise.resolve(); }

 	var wasmImportObjects = {
 		"f141": function() {
 			return {
 				"./pibench_parser_bg.js": {
 					"__wbindgen_json_parse": function(p0i32,p1i32) {
 						return installedModules["ebb5"].exports["e"](p0i32,p1i32);
 					},
 					"__wbg_new_59cb74e423758ede": function() {
 						return installedModules["ebb5"].exports["c"]();
 					},
 					"__wbg_stack_558ba5917b466edd": function(p0i32,p1i32) {
 						return installedModules["ebb5"].exports["d"](p0i32,p1i32);
 					},
 					"__wbg_error_4bb6c2a97407129a": function(p0i32,p1i32) {
 						return installedModules["ebb5"].exports["b"](p0i32,p1i32);
 					},
 					"__wbindgen_object_drop_ref": function(p0i32) {
 						return installedModules["ebb5"].exports["f"](p0i32);
 					},
 					"__wbindgen_throw": function(p0i32,p1i32) {
 						return installedModules["ebb5"].exports["g"](p0i32,p1i32);
 					}
 				}
 			};
 		},
 	};

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-1c946adc":1,"chunk-af25d5ee":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-47e91daa":"31d6cfe0","chunk-1c946adc":"e78dfcdd","chunk-af25d5ee":"ef0fc14a","chunk-0b65ffb6":"31d6cfe0","chunk-2d0a3577":"31d6cfe0","chunk-2d0a43df":"31d6cfe0","chunk-2d0aa90c":"31d6cfe0","chunk-2d0aab07":"31d6cfe0","chunk-2d0abc00":"31d6cfe0","chunk-2d0ae937":"31d6cfe0","chunk-2d0aeb45":"31d6cfe0","chunk-2d0af08c":"31d6cfe0","chunk-2d0afa49":"31d6cfe0","chunk-2d0b6187":"31d6cfe0","chunk-2d0ba136":"31d6cfe0","chunk-2d0bb267":"31d6cfe0","chunk-2d0bcec1":"31d6cfe0","chunk-2d0bdf38":"31d6cfe0","chunk-2d0bff92":"31d6cfe0","chunk-2d0c0494":"31d6cfe0","chunk-2d0c0a09":"31d6cfe0","chunk-2d0c4313":"31d6cfe0","chunk-2d0c46d1":"31d6cfe0","chunk-2d0c512b":"31d6cfe0","chunk-2d0cf16e":"31d6cfe0","chunk-2d0d056d":"31d6cfe0","chunk-2d0d0645":"31d6cfe0","chunk-2d0d2f22":"31d6cfe0","chunk-2d0d61fd":"31d6cfe0","chunk-2d0d7e63":"31d6cfe0","chunk-2d0e1b57":"31d6cfe0","chunk-2d0e1fbe":"31d6cfe0","chunk-2d0e22d6":"31d6cfe0","chunk-2d0e542a":"31d6cfe0","chunk-2d0e57ec":"31d6cfe0","chunk-2d0e6553":"31d6cfe0","chunk-2d0e6c86":"31d6cfe0","chunk-2d0ea098":"31d6cfe0","chunk-2d0f0a11":"31d6cfe0","chunk-2d208ac5":"31d6cfe0","chunk-2d209408":"31d6cfe0","chunk-2d20f745":"31d6cfe0","chunk-2d20ff23":"31d6cfe0","chunk-2d2138c7":"31d6cfe0","chunk-2d216f3b":"31d6cfe0","chunk-2d217e5b":"31d6cfe0","chunk-2d21b84a":"31d6cfe0","chunk-2d21dcd2":"31d6cfe0","chunk-2d21f327":"31d6cfe0","chunk-2d2214b3":"31d6cfe0","chunk-2d221799":"31d6cfe0","chunk-2d221814":"31d6cfe0","chunk-2d221a34":"31d6cfe0","chunk-2d22502a":"31d6cfe0","chunk-2d226775":"31d6cfe0","chunk-2d229411":"31d6cfe0","chunk-2d2295e9":"31d6cfe0","chunk-2d22c171":"31d6cfe0","chunk-2d22c2b8":"31d6cfe0","chunk-2d22ca58":"31d6cfe0","chunk-2d2311f7":"31d6cfe0","chunk-2d237ee7":"31d6cfe0","chunk-2d238465":"31d6cfe0","chunk-30597b4a":"31d6cfe0","chunk-7459c510":"31d6cfe0","chunk-7532b3ea":"31d6cfe0","chunk-e13e4362":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}

 		// Fetch + compile chunk loading for webassembly

 		var wasmModules = {"chunk-47e91daa":["f141"]}[chunkId] || [];

 		wasmModules.forEach(function(wasmModuleId) {
 			var installedWasmModuleData = installedWasmModules[wasmModuleId];

 			// a Promise means "currently loading" or "already loaded".
 			if(installedWasmModuleData)
 				promises.push(installedWasmModuleData);
 			else {
 				var importObject = wasmImportObjects[wasmModuleId]();
 				var req = fetch(__webpack_require__.p + "" + {"f141":"f7ff8c44f3b733d80737"}[wasmModuleId] + ".module.wasm");
 				var promise;
 				if(importObject instanceof Promise && typeof WebAssembly.compileStreaming === 'function') {
 					promise = Promise.all([WebAssembly.compileStreaming(req), importObject]).then(function(items) {
 						return WebAssembly.instantiate(items[0], items[1]);
 					});
 				} else if(typeof WebAssembly.instantiateStreaming === 'function') {
 					promise = WebAssembly.instantiateStreaming(req, importObject);
 				} else {
 					var bytesPromise = req.then(function(x) { return x.arrayBuffer(); });
 					promise = bytesPromise.then(function(bytes) {
 						return WebAssembly.instantiate(bytes, importObject);
 					});
 				}
 				promises.push(installedWasmModules[wasmModuleId] = promise.then(function(res) {
 					return __webpack_require__.w[wasmModuleId] = (res.instance || res).exports;
 				}));
 			}
 		});
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	// object with all WebAssembly.instance exports
 	__webpack_require__.w = {};

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
